import { select } from "redux-saga/effects";
import translationsGe from "src/settings/translation/locales/ge";
import translationsEn from "src/settings/translation/locales/en";

export function* formatByIdSaga(intlId) {
  const language = yield select(state => state.common.lang);
  const messages = { ge: translationsGe, en: translationsEn }[language];
  const text = messages?.[intlId];
  if (!text)
    console.error(`could not translate intlId ${intlId}`);
  return text;
}
